<template>
  <div>
    <div class="chatbot-a" v-html="question" />
    <div class="clear-float"></div>
  </div>
</template>

<script>
export default {
  name: "AskQuestion",
  data() {
    return {};
  },
  props: {
    question: String,
  },
};
</script>

<style>
.chatbot-a {
  float: right;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #d72618;
  color: #fff;
  max-width: 80%;
  line-height: 30px;
  padding: 10px 15px;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 35px;
}
.clear-float {
  clear: both;
}
</style>
